import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { CheckpointInboxPage } from "@/features/checkpoints/pages/checkpoint-inbox-page";
import { requireFeatureEnabled } from "@/features/features";

// Status tab preserved in URL search param so F5 / share-link restores the active tab.
const checkpointSearchSchema = z.object({
  status: z.enum(["pending", "approved", "rejected", "expired", "cancelled"]).optional().catch(undefined),
});

export const Route = createFileRoute("/_admin/checkpoints/")({
  beforeLoad: () => requireFeatureEnabled("workflows"),
  validateSearch: checkpointSearchSchema.parse,
  component: CheckpointInboxPage,
});
